// extracted by mini-css-extract-plugin
export default {"myVideo":"Login_myVideo__NbwVf"};